// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
// State
import { AppState } from '../../reducers';
import {
  selectPrescriptionsInStore,
  selectPrescriptionsPageLoading,
  selectPrescriptionsShowInitWaitingMessage,
} from '../_selectors/prescription.selectors';

export class PrescriptionsDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectPrescriptionsPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(select(selectPrescriptionsShowInitWaitingMessage));

    this.store.pipe(select(selectPrescriptionsInStore)).subscribe((response: QueryResultsModel) => {
      this.paginatorTotalSubject.next(response.totalCount);
      this.entitySubject.next(response.items);
    });
  }
}
